export const ROLES = [
  "admin",
  "kasir",
  "desain",
  "op_outdoor_finishing",
  "op_dtf",
  "op_press_satuan",
  "op_press_roll",
  "pattern_layout",
  "op_sublim",
  "op_press",
  "jahit",
  "qc",
  "op_digital",
  "finance",
  "manager",  // owner 2026-10-11/12: watches all production, no money (server: app/services/peran.py)
];

export const ROLE_LABELS = {
  admin: "Owner",  // v2.22.1 (owner 2026-10-29): was "Administrator"; that name is now the server mark below
  kasir: "Kasir/CS",  // Addendum 5: front desk (cashier + customer service)
  desain: "Desain",  // Addendum 5: designer (was "CS / Desain")
  op_outdoor_finishing: "Op. Outdoor & Finishing",
  op_dtf: "Op. DTF",
  op_press_satuan: "Op. Press Satuan",
  op_press_roll: "Op. Press Roll",
  pattern_layout: "Pattern & Layout",
  op_sublim: "Op. Sublim",
  op_press: "Op. Press",
  jahit: "Jahit",
  qc: "Quality Control",
  op_digital: "Op. Digital (Indoor/Laser/Epson/Cutting/Lainnya)",
  finance: "Finance",
  manager: "Manager",
};

// v2.22.1: an Owner account named in ADMIN_TEKNIS on the server (iartech) is also "Administrator"
export const labelPeran = (u) => (u?.role === "admin" && u?.administrator ? "Owner · Administrator" : ROLE_LABELS[u?.role] || u?.role);

// Office roles have no production queue.
// owner 2026-10-12: the Manager is excluded EXPLICITLY — never an operator
export const BUKAN_OPERATOR = ["admin", "kasir", "finance", "manager"];
export const OPERATOR_ROLES = ROLES.filter((r) => !BUKAN_OPERATOR.includes(r));
// see every station (all queues, monitoring, reassigning work)
export const PENGAWAS = ["admin", "manager"];
export const PRODUCTION_ROLES = [...PENGAWAS, ...OPERATOR_ROLES];
// accounts a Manager may manage (the server checks the same list)
export const KARYAWAN = [...OPERATOR_ROLES, "kasir"];
